import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 10px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};
  padding-bottom: 40px;
  /* variant: "light" deixa o texto preto (Admin); o branco é o padrão (área comum). */
  color: ${({ theme, variant }) =>
    variant === "light"
      ? theme.colors.neutral.black
      : theme.colors.neutral.white};

  grid-area: ${({ gridArea }) => gridArea};
`;

export const Commitments = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;

  width: 100%;
`;

export const Commitment = styled.img`
  width: 110px;
  height: 110px;
  cursor: pointer;

  /* variant "light" (Admin): borda azul mais grossa + brilho para maior destaque
     do item selecionado. Padrão (área comum) mantém a borda fina. */
  border: ${({ theme, selected, variant }) =>
    selected
      ? `${variant === "light" ? "4px" : "2px"} solid ${theme.colors.primary.blue}`
      : "none"};

  box-shadow: ${({ theme, selected, variant }) =>
    selected && variant === "light"
      ? `0 0 0 3px ${theme.colors.primary.blue}`
      : "none"};

  opacity: ${({ selected, variant }) =>
    variant === "light" && !selected ? 0.55 : 1};

  transition:
    border 0.03s,
    box-shadow 0.03s,
    opacity 0.03s;
`;
